export const contactActionTypes = {
    CONTACT_US_ACTION: 'CONTACT_US_ACTION',
    CONTACT_US_EMAIL_ACTION: 'CONTACT_US_EMAIL_ACTION',
    CONTACT_US_NAME_ACTION: 'CONTACT_US_NAME_ACTION',
    CONTACT_US_MESSAGE_ACTION: 'CONTACT_US_MESSAGE_ACTION',
    CONTACT_US_ACTION_SAVE : 'CONTACT_US_ACTION_SAVE',
    CONTACT_US_FAILURE: 'CONTACT_US_FAILURE',
    CONTACT_US_SUCCESS: 'CONTACT_US_SUCCESS',
}
